





import { defineComponent, reactive } from '@vue/composition-api';

import PanelWithMiscPurchaseRequest from '@/components/PurchaseRequest/PanelWithMiscPurchaseRequest.vue';

const CreateMisc = defineComponent({
  components: {
    PanelWithMiscPurchaseRequest,
  },
});

export default CreateMisc;
